module.exports = __webpack_public_path__ + "static/media/Delete.6aae386b.svg";